import router from '@/router'
import { useAuth } from '@simplifi/auth'
import type { LDMultiKindContext } from 'launchdarkly-js-client-sdk'
import { ldInit, useLDFlag } from 'launchdarkly-vue-client-sdk'
import { toRef } from 'vue'

export function init() {
  const { session, loggedIn } = useAuth()

  if (!loggedIn.value) {
    throw new Error('Attempted to initialize LaunchDarkly without a session')
  }

  const context: LDMultiKindContext = {
    kind: 'multi',
    user: {
      anonymous: false,
      key: session.value.userId,
      name: session.value.userName,
      email: session.value.email,
    },
  }

  try {
    const [, client] = ldInit({ context })
    client.on('failed', (err) => {
      console.error('LD Failed to init', err)
      router.push({ name: 'permissionError' })
    })
    client.on('error', (err) => {
      console.error('LD Errored on init', err)
      router.push({ name: 'permissionError' })
    })
    return client
  } catch (error) {
    console.error('LD Failed to init', error)
  }

  router.push({ name: 'permissionError' })
}

export function useFlag(flagName: string, defaultValue = false) {
  try {
    return useLDFlag(flagName, defaultValue)
  } catch {
    return toRef(defaultValue)
  }
}

export const flag = {
  contactCustomer: () => useFlag('wip-823-contact-customer-button'),
  bestAvailableEta: () => useFlag('fnol-629-best-available-eta'),
  editVisitInfo: () => useFlag('wip-884-edit-visit-info'),
  calculatedStatuses: () => useFlag(flagName.calculatedStatuses),
  alignedTimers: () => useFlag(flagName.alignedTimers),
  correctAssignedStatus: () => useFlag('fnol-792-correct-assigned-status'),
}

// Note: For use outside of Vue components using useLDClient()
export const flagName = {
  calculatedStatuses: 'wip-929-contractor-calc-statuses',
  alignedTimers: 'wip-907-aligned-timers',
}
